/**
 * This file was auto-generated by Fern from our API Definition.
 */

/**
 * Secret key in JWK format.
 *         Take a look [RFC 7517](https://datatracker.ietf.org/doc/html/rfc7517).
 */
export type KeySecretJwk = string;
